import axios from 'axios'
import reqBase from '@/_helpers/requests/reqBase'

const request = axios.create()

request.interceptors.request.use(
    config => reqBase.interceptorsRequest(config))

    request.interceptors.response.use(function (response) {
        return response;
    }, function (error) {
    
        reqBase.unauthorizedResponse(error.response);
    
        return Promise.reject(error);
    });

export default request